module.exports = __webpack_public_path__ + "img/agregar_foto.2ca459f7.jpg";